<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="1000px"
    :innerScroll="false"
    @close="onCancel"
    :showFooter="false"
  >
    <el-table
      v-loading="loading"
      ref="table"
      border
      :height="300"
      :data="tableData.records"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
    >
      <!-- <el-table-column :show-overflow-tooltip="true" prop="tagName" label="店铺"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="optionTypeName" :label="thisYear + '销量'"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="sort" :label="lastYear + '销量'"></el-table-column>
      <el-table-column :show-overflow-tooltip="true" prop="optionValue" label="同比"></el-table-column> -->
      <el-table-column
        v-for="(item, index) in columnData"
        :key="index"
        :sortable="item.sortable ? 'custom' : false"
        show-overflow-tooltip
        :label="item.displayName"
        :fixed="item.freezeType"
        :prop="item.columnName"
        :min-width="item.displayWidth"
      >
        <template slot-scope="scope">
          {{ scope.row[item.columnName] }}
        </template>
      </el-table-column>
    </el-table>
  </q-dialog>
</template>

<script>
import moment from "moment";
import axios from "@/utils/axiosInstance";
export default {
  name: "CRUDEdit",
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "各店铺" + (this.rowData.type == '销量' ? '销量' : '销售额');
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      categoryList: [],
      bigModelList: [],
      columnData: [],
      tableData: {
        records: []
      },
      rules: {},
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      thisYear: moment().format("YYYY"),
      lastYear: moment().subtract(1, "year").format("YYYY"),
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
      });
    },
    init() {
      this.loading = true;
      let logType = this.rowData.type == "销量" ? this.$q.productModelDetails.keyProductsStoreSales : this.$q.productModelDetails.keyProductsStoreSalesAmount;
      logType({ data: this.rowData })
        .then((res) => {
          this.tableData = res.data;
          this.columnData = res.data.titleList.map((v) => {
            return {
              ...v,
              displayName: v.titleName,
              columnName: v.propertyName,
              displayWidth: "150px",
              sortable: v.sortable == 1 ? "custom" : false,
              span: false,
              freezeType: v.fixed == "1" ? "left" : false,
            };
          });
        })
        .finally((_) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 170px !important;
}
.content {
  max-height: 70vh
  overflow-y: auto
  text-align: center
}
</style>
